// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1NCBV","modalFooterButton":"ModalNotes_modalFooterButton__1Ttxu"};